import styled from "styled-components";

export const Body = styled.div`

    min-height: 100vh;
    width: 100%;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    background-color: #F2F1EE;
    background-image:
        repeating-linear-gradient(0deg, rgba(0, 0, 0, 0.03) 0 1px, transparent 1px 40px),
        repeating-linear-gradient(90deg, rgba(0, 0, 0, 0.03) 0 1px, transparent 1px 40px);
    font-family: Verdana, Geneva, Tahoma, sans-serif;
    color: #171717;
`

export const BotaoLeft = styled.div`
    margin-top: 3vh;
    margin-left: 3vh;
    border: none;
    .left{ width: 5vw }

    img{
        border-radius: 50%;
        transition: transform 0.15s ease, box-shadow 0.15s ease;

        :hover{
            transform: scale(1.08);
            box-shadow: 0 0 0 4px rgba(240, 82, 79, 0.25);
            }
    }

    @media screen and (max-width: 760px) {
        display: none;
    }
`

export const TopoSeta = styled.div`

    display: flex ;
    flex-shrink: 0 ;
    margin-bottom: 1vh ;
`

export const Videos = styled.div`

    flex: 1;
    width: 100%;
    box-sizing: border-box;
    display: flex;
    justify-content: center;
    padding: 1vh 3vw 5vh;

    .painel {
        width: 100%;
        max-width: 1180px;
        background-color: #fff;
        border: 2px solid #e2e2e2;
        border-radius: 1vw;
        box-shadow: 0 10px 30px rgba(0, 0, 0, 0.06);
        padding: 1.6vw 2.4vw 2vw;
        box-sizing: border-box;
    }

    .topo {
        text-align: center;
        margin-bottom: 0.5vw;
        font-size: 1.6vw;
        font-weight: 800;
        color: #171717;
        line-height: 1.2;
    }

    hr {
        border: none;
        border-top: 2px solid #F5A623;
        margin: 0 0 1.6vw;
    }

    .grid-videos {
        display: flex;
        flex-wrap: wrap;
        justify-content: center;
        gap: 1.6vw;
    }

    .videosemlinha {
        width: 26vw;
        max-width: 380px;
        background-color: #fff;
        border: 2px solid #e2e2e2;
        border-radius: 0.8vw;
        box-shadow: 0 6px 18px rgba(0, 0, 0, 0.05);
        padding: 0.9vw;
        box-sizing: border-box;

        label {
            display: block;
            text-align: center;
            font-weight: 700;
            font-size: 0.95vw;
            color: #171717;
            margin-bottom: 0.6vw;
        }

        .video-wrap {
            position: relative;
            width: 100%;
            aspect-ratio: 16 / 9;
            background-color: #000;
            border-radius: 0.5vw;
            overflow: hidden;
        }

        .video {
            position: absolute;
            inset: 0;
            width: 100%;
            height: 100%;
            object-fit: contain;
            background-color: #000;
        }
    }

    @media screen and (max-width: 760px) {

        padding: 1vh 5vw 8vh;

        .painel {
            border-radius: 3vw;
            padding: 6vw 5vw 8vw;
        }

        .topo {
            font-size: 6vw;
            margin-bottom: 4vw;
        }

        hr {
            margin-bottom: 5vw;
        }

        .grid-videos {
            flex-direction: column;
            align-items: center;
            gap: 6vw;
        }

        .videosemlinha {
            width: 100%;
            max-width: none;
            border-radius: 3vw;
            padding: 4vw;

            label {
                font-size: 4vw;
                margin-bottom: 3vw;
            }

            .video-wrap {
                border-radius: 2vw;
            }
        }
    }
`
